import React, { useCallback, useRef } from 'react';
import { element, object } from 'prop-types';
import { useClickEvent } from 'hooks/use-internal-clicks.js';
import { BgLayer } from '../bg-layer.jsx';
import { useExternalControl } from 'hooks/use-external-control.js';
import { useAutoClick } from './use-auto-click.jsx';
import { useAutoSubmitVote } from './use-auto-submit-vote.jsx';
import styles from './button.module.css';
import { useSetDataAttrs } from '#/hooks/index.js';

Button.propTypes = {
  desc: object,
  children: element,
};

export default function Button(props) {
  const {
    desc,
    desc: {
      id,
      role,
      disabled,
      children,
      isMainTarget,
      autoFocus,
      autoClick,
      className,
      /*
            borderRadius,
      */
      /*
        default button does not have any background except fill,
       but poll's buttons as same as close button may
       */
      backgrounds = [],
      version,
      width
    },
  } = props;

  /**
   * @type {React.RefObject<HTMLButtonElement>}
   */
  const ref = useRef(null);
  useExternalControl(ref);
  const onClick = useClickEvent(desc);
  const onAutoClick = useCallback(() => {
    ref.current.dataset.etElAutoClick = 'true';
    ref.current.click();
  }, []);
  const indicator = useAutoClick(ref, Boolean(autoClick), {
    ...autoClick,
    width,
    /*
        borderRadius,
    */
    onTimeout: onAutoClick,
  });

  useAutoSubmitVote(desc, ref);

  useSetDataAttrs(ref, desc.dataset);

  return (
    <button
      id={id}
      ref={ref}
      className={`${isMainTarget ? 'mainTarget' : ''} ${className ?? ''} buttonWidget ${styles.buttonWidget}`}
      role={role}
      form={desc.formId}
      type={Boolean(desc.formId) ? 'submit' : 'button'}
      disabled={disabled || desc.autoVote}
      onClickCapture={onClick}
      data-auto-focus={autoFocus}
      data-main-target={isMainTarget || undefined}
    >
      <div role="outline-decorator" />
      {backgrounds.map((background) => (
        <BgLayer key={background.id} desc={background} />
      ))}
      {indicator}
      {children.map((child) => (
        <child.type key={child.key} desc={child} />
      ))}
      {version === 2 && role === 'closeButton' && (
        <svg role="close-icon" viewBox="0 0 20 20">
          <path
            d="M4.375 4.375L15.0892 15.0892M15.0892 4.375L4.375 15.0892"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  );
}
